import type { Guard } from './types'
import { Routes } from '../../Constants/Routes.ts'

export function createAuthenticatedGuard(): Guard {
  return () => {
    if (user !== null) {
      return true
    }

    return { name: Routes.LOGIN }
  }
}

export function createNotAuthenticatedGuard(): Guard {
  return () => {
    if (user === null) {
      return true
    }

    return { name: Routes.HOME }
  }
}
